import { render, staticRenderFns } from "./WorkShiftsViewPage.vue?vue&type=template&id=180692bc&"
import script from "./WorkShiftsViewPage.vue?vue&type=script&lang=js&"
export * from "./WorkShiftsViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports